module.exports = __webpack_public_path__ + "static/hero-devices-bb0b1796751d1da43780f60368e050dd.svg";